import styled from 'styled-components'

export const Container = styled.div``

export const TitleContainer = styled.div`
  margin-bottom: 10px;
`
